import React, { Component } from 'react'
import './index.css'


export default class Specifications extends Component {
  render() {
    const { usps } = this.props.data

    return (
      <div className="Specifications">
        {usps.map((x, i) =>
          <div key={`specifications-box-${i}`} className="box">
            <div className="wrap">
              <i style={{
                backgroundImage: `url(${x.icoon.url})`
              }} />
              <h3>{x.titel}</h3>
              <p>{x.beschrijving}</p>
            </div>
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/Specifications/index.js